import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";

const RecentTransactions = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center mx-4 justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg w-[full] lg:w-[400px] pb-6 shadow-lg">
        <div className="flex items-center justify-between p-[20px] border-b-[#ececfe] border-b-[1px]">
          <div className="text-[#000] text-[20px] font-[500]">
            Recent Transactions
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 text-[20px] hover:text-gray-700"
          >
            <RxCross2 />
          </button>
        </div>
        <div className="px-[20px] pt-6">
          <div className="text-[20px] text-center text-[#8c8cb1] font-[600]">
            Please connect your wallet to view your recent transactions
          </div>
          <div className="flex justify-center">
            <button
              type="button"
              className="w-auto mt-[10px] px-5 h-[40px] bg-[green] rounded-[99px] flex items-center justify-center text-[#fff]"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentTransactions;
